import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import LengthIcon from '../../../../../components/icons/length-icon.svg';
import WidthIcon from '../../../../../components/icons/width-icon.svg';
import HeightIcon from '../../../../../components/icons/height-icon.svg';
import { KgIcon, SizeTextIcon } from '../../../../../components/text-icon';
import { CustomLoader } from '../../../../../components/custom-loader';
import { ErrorComponent } from '../../../../../components/error-component';

export const ThermoboxFormView = ({ partnersOptions, isPartnersLoading, isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="thermobox-form">
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Название
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Производитель
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Field
						name="partner_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={partnersOptions}
						search
						loading={isPartnersLoading}
						disabled={isPartnersLoading}
						noResultsMessage="Компании не найдены"
						placeholder="Выберите производителя"
						isWithoutSelectOnBlur
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Внешние геометрические размеры
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Grid columns={3} className="thermobox-form__wrapper">
						<Grid.Row className="thermobox-form__row thermobox-form__row-cargo">
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={LengthIcon} alt="length-icon" />
								<div className="thermobox-form__field">
									<Field
										name="outer_length"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Дл."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={WidthIcon} alt="width-icon" />
								<div className="thermobox-form__field">
									<Field
										name="outer_width"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Шир."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={HeightIcon} alt="height-icon" />
								<div className="thermobox-form__field">
									<Field
										name="outer_height"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Выс."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row className="thermobox-form__row thermobox-form__row-cargo thermobox-form__row-error">
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="outer_length" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="outer_width" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="outer_height" component={ErrorComponent} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Внутренние геометрические размеры
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Grid columns={3} className="thermobox-form__wrapper">
						<Grid.Row className="thermobox-form__row thermobox-form__row-cargo">
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={LengthIcon} alt="length-icon" />
								<div className="thermobox-form__field">
									<Field
										name="inner_length"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Дл."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={WidthIcon} alt="width-icon" />
								<div className="thermobox-form__field">
									<Field
										name="inner_width"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Шир."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={HeightIcon} alt="height-icon" />
								<div className="thermobox-form__field">
									<Field
										name="inner_height"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Выс."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row className="thermobox-form__row thermobox-form__row-cargo thermobox-form__row-error">
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="inner_length" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="inner_width" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="inner_height" component={ErrorComponent} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Масса пустого
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Field
						name="empty_weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите массу пустого"
						icon={KgIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Габариты паллета
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Grid columns={3} className="thermobox-form__wrapper">
						<Grid.Row className="thermobox-form__row thermobox-form__row-cargo">
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={LengthIcon} alt="length-icon" />
								<div className="thermobox-form__field">
									<Field
										name="pallet_length"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Дл."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={WidthIcon} alt="width-icon" />
								<div className="thermobox-form__field">
									<Field
										name="pallet_width"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Шир."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo" width={5}>
								<img src={HeightIcon} alt="height-icon" />
								<div className="thermobox-form__field">
									<Field
										name="pallet_height"
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={SizeTextIcon}
										placeholder="Выс."
										isWithoutErrorText
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
						<Grid.Row className="thermobox-form__row thermobox-form__row-cargo thermobox-form__row-error">
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="pallet_length" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="pallet_width" component={ErrorComponent} />
							</Grid.Column>
							<Grid.Column className="thermobox-form__column-cargo-error" width={16}>
								<Field name="pallet_height" component={ErrorComponent} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="thermobox-form__row">
				<Grid.Column width={6} className="thermobox-form__column">
					Масса паллета
				</Grid.Column>
				<Grid.Column width={8} className="thermobox-form__column">
					<Field
						name="pallet_weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите массу паллета"
						icon={KgIcon}
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

ThermoboxFormView.propTypes = {
	partnersOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isPartnersLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
};
